import { FERRAMENTA_IDS } from '@components/ferramentas/FerramentaRouter.js'

import { GUIA_LABELS } from '@utils/guiaLabels.js'

export type TopicoTipo = 'ferramenta' | 'conteudo' | 'placeholder'

export function getTopicoTipo(_moduloId: string, _slug: string, topicoId: string): TopicoTipo {
  if (FERRAMENTA_IDS.has(topicoId)) return 'ferramenta'
  return 'placeholder'
}

export const TIPO_LABEL: Record<TopicoTipo, string> = {
  ferramenta: GUIA_LABELS.tipoFerramenta,
  conteudo: 'Orientação',
  placeholder: 'Em breve',
}

export const TIPO_CLASS: Record<TopicoTipo, string> = {
  ferramenta: 'cf3-badge cf3-badge--ferramenta',
  conteudo: 'cf3-badge cf3-badge--referencia',
  placeholder: 'cf3-badge cf3-badge--camada',
}

/** Compat legado — sem emojis */
export const TIPO_ICON: Record<TopicoTipo, string> = {
  ferramenta: '',
  conteudo: '',
  placeholder: '',
}
